import { getInitialState } from './initialState';

const initialState = getInitialState(typeof window === 'undefined');

const accountReducer = (state = initialState) => {
  return state;
};

export default accountReducer;
